import React from "react";

export const DownloadIcon: React.FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <>
      <svg
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 20 20"
        className={className}
      >
        <path d="M5.09961 16.4707C4.68294 16.4707 4.32894 16.3247 4.03761 16.0327C3.74561 15.7414 3.59961 15.3874 3.59961 14.9707V13.4707H5.09961V14.9707H14.0996V13.4707H15.5996V14.9707C15.5996 15.3874 15.4536 15.7414 15.1616 16.0327C14.8703 16.3247 14.5163 16.4707 14.0996 16.4707H5.09961ZM9.59961 13.4707L5.59961 9.4707L6.66161 8.4087L8.84961 10.5957V3.4707H10.3496V10.5957L12.5376 8.4087L13.5996 9.4707L9.59961 13.4707Z" />
      </svg>
    </>
  );
};
